import React, { FC, useEffect }from "react";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { Configuration, PublicClientApplication, InteractionType } from "@azure/msal-browser";

const clientId = (window.location.hostname === "localhost" || window.location.hostname.includes("dev")) ? "24e54480-4e73-40b9-8fea-c93214ef5b0c" 
                    : window.location.hostname.includes("ppe") ? "b2cda1ad-3ed3-4eb3-9bb3-0fdfca9a7fdf"
                    : "617e1c35-19e4-4859-8722-7dd1d627ff02";

// MSAL configuration
const configuration: Configuration = {
    auth: {
        clientId: clientId,
        authority: "https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47/",
        redirectUri: `${window.location.origin}`
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    }
};

export const pca = new PublicClientApplication(configuration);

export const authRequest = {
    scopes: ["User.Read"]
};

// Component
export const AuthHandler: FC<{}> = (props) => {
    useEffect(() => {
        (window as any).msal = pca; // need to make the pca variable global so we can initialize mecontrol
    }, []);

    return (
        <MsalProvider instance={pca}>
            <MsalAuthenticationTemplate 
                interactionType={InteractionType.Redirect} 
                authenticationRequest={authRequest} 
            >
                {props.children}
            </MsalAuthenticationTemplate>
        </MsalProvider>
    )
};